import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Grid,
  List,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { showSuccessToast, showErrorToast } from "../../utils/toaster";
import { baseurl } from "../../config/url";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close"; 

// Function to format MongoDB date into a readable format
const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-IN", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

const UpdateProfile = () => {
  const navigate = useNavigate();
  const [sellerDetails, setSellerDetails] = useState({address: {}, });
  const [isLoading, setIsLoading] = useState(false);

  const sellerId = localStorage.getItem("sellerId");

  const fetchSellerDetails = async () => {
    if (!sellerId) return;
    try {
      setIsLoading(true);
      const response = await axios.get(`${baseurl}/api/seller/seller-by-id/${sellerId}`);
      setSellerDetails(response.data);
      console.log("Fetched Seller Details:", response.data); // Debugging
  } catch (error) {
      showErrorToast("Failed to fetch seller details");
  } finally {
      setIsLoading(false);
  }
};

  const handleUpdate = async () => {
    try {
      const response = await axios.put(
        `${baseurl}/api/seller/updateSeller/${sellerId}`,
        sellerDetails
      );
      showSuccessToast(response.data.message);
      navigate("/seller");
    } catch (error) {
      showErrorToast(error.response?.data?.message || "Failed to update details");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (["street", "city", "state", "country", "postalCode"].includes(name)) {
      // Update nested address fields
      setSellerDetails((prevState) => ({
        ...prevState,
        address: { ...prevState.address, [name]: value },
      }));
    } else {
      // Update top-level fields
      setSellerDetails((prevState) => ({ ...prevState, [name]: value }));
    }
  };
  
  const handleClose = () => {
    navigate(-1); // Navigate to the previous page
  };

  useEffect(() => {
    fetchSellerDetails();
  }, []);

  return (
   <div className="p-4">
      {/* Cross Button at the Top */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h2 style={{ fontSize: "1.5rem", marginBottom: "16px" }}>Update Profile</h2>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </div>
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <List>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Name"
                name="name"
                value={sellerDetails.name || ""}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                value={sellerDetails.email || ""}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Mobile"
                name="mobile"
                value={sellerDetails.mobile || ""}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Company Name"
                name="companyName"
                value={sellerDetails.companyName || ""}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="GST Number"
                name="gstNumber"
                value={sellerDetails.gstNumber || ""}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="PAN Number"
                name="pan"
                value={sellerDetails.pan || ""}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="Street"
                        name="street"
                        value={sellerDetails.address?.street || ""}
                        onChange={handleInputChange}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="City"
                        name="city"
                        value={sellerDetails.address?.city || ""}
                        onChange={handleInputChange}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="State"
                        name="state"
                        value={sellerDetails.address?.state || ""}
                        onChange={handleInputChange}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="Country"
                        name="country"
                        value={sellerDetails.address?.country || ""}
                        onChange={handleInputChange}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="Postal Code"
                        name="postalCode"
                        value={sellerDetails.address?.postalCode || ""}
                        onChange={handleInputChange}
                      />
                    </Grid>
                    {/* Registration Date (Read-Only) */}
                    <Grid item xs={6}>
  <TextField
    fullWidth
    label="Registration Date"
    value={formatDate(sellerDetails.createdAt)}
    disabled
  />
</Grid>
                   
                   
                   
          </Grid>
          <Grid item xs={12}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleUpdate}
                  style={{
                    maxWidth: "300px", // Set the maximum width of the button
                    width: "100%", // Ensure it scales properly on smaller screens
                    padding: "12px",
                    fontSize: "1rem",
                  }}
                >
            Update Profile
          </Button>
          </div>
            </Grid>

        </List>
      )}
    </div>
  );
};

export default UpdateProfile;
